import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
// vue store
export default new Vuex.Store({
	state: {
		// wordpress page slug.
		slug : null,
		// WooCommerce product data
		product : {
			slug : null,
			id : null
		},
		// Worpress Nonce
		wp_nonce : null,
		current_step: 'choose-size',
		total : 0,
		bed_sizes: [],
		wallbed: {},
		woods: [],
		wood_finishes:  [],
		popular_finishes : [],
		sofa_fabrics: [],
		mattresses : [],
		// selected items
		selected_size: null,
		selected_wood : null,
		selected_finish : null,
		depth_prices : [],
		front_panel_upcharges : [],
		desk_table_options : [],
		additional_options : [],
		selected_headboard : null,
		selected_desk_table : null,
		selected_options : [],
		cabinet_sizes : {},
		cabinet_size_options : [],
		selected_cabinet_left: null,
		selected_cabinet_right: null,
		current_info_data : {},
		selected_mattress : null,
		selected_popular_finish : null,
		selected_fabric : null,
		totals : {},
		left_cabinet_night_tray : false,
		right_cabinet_night_tray : false,
		left_cabinet_glass_doors : false,
		right_cabinet_glass_doors : false,
		left_cabinet_glass_shelves : false,
		right_cabinet_glass_shelves : false,
		selected_left_cabinet_size : "none",
		selected_right_cabinet_size : "none",
		selected_left_cabinet_style : null,
		selected_right_cabinet_style: null,
		pricing_items : {},
		cabinetBed: null,
		cabinetBedColor: null,
		useDiscounts: false,
		// field mapping for request follow form.
		followup_mapping: {
			form_id : 6,
			style : 5,
			size : 6,
			wood : 7,
			finish : 8,
			headboard : 9,
			drop_down_table : 10,
			additional_options : 12,
			left_cabinet : 11,
			left_cabinet_width : 14,
			right_cabinet : 15,
			right_cabinet_width : 16,
			mattress : 17
		},
	},
	mutations: {
		/**
		 * save the slug for the wallbed in the state object
		 * @param {[type]} state   [description]
		 * @param {[type]} payload [description]
		 */
		setSlug(state,payload){
			state.slug = payload;
			state.product.slug = payload;
		},
		setProduct(state,payload){
			state.product.id = payload;
		},
		/**
		 * Sets the discount state based on the provided payload.
		 *
		 * @param {Object} state - The current state object which holds the useDiscounts property.
		 * @param {boolean|string} payload - Determines whether discounts should be applied. Can be a boolean or a string.
		 * @return {void}
		 */
		setDiscounts(state,payload){
			if(payload === true || payload.toLowerCase() === 'true'){
				state.useDiscounts = true;
			} else {
				state.useDiscounts = false;
			}
		},
		/**
		 * toggle current step in state
		 * @param {[type]} state   [description]
		 * @param {[type]} payload [description]
		 */
		setCurrentStep(state,payload){
			state.current_step = payload;
		},
		/**
		 * get raw JSON response and seperate it for easier use
		 * @param {[type]} state   [description]
		 * @param {[type]} payload [description]
		 */
		setWallbedData(state,payload){
			if(payload.type === "cabinet-bed"){
				state.wallbed = null;
				state.cabinetBed = payload;
				state.mattresses = payload.mattresses;
				state.additional_options = payload.options;
				state.cabinetBedColor = payload.colors[0];
				if(document.cabinetBedCalculator && state.cabinetBed != null && state.cabinetBed.type){
					document.cabinetBedCalculator.calculateTotals();
				}
				return;
			}
			// saw all data
			state.wallbed = payload;
			// handle sizes
			state.bed_sizes = payload.sizes;
			//  depth prices (for head boards)
			state.depth_prices = payload.depth_prices;
			// 
			state.front_panel_upcharges = payload.front_panel_upcharges;
			//
			state.additional_options = payload.options;
			// seperate cabinets based on width
			
			// popular finishes
			state.popular_finishes = payload.popular_finishes;
			
			if(payload.fabrics){
				state.sofa_fabrics = payload.fabrics;
				state.selected_fabric = state.sofa_fabrics[0];
			}

			let cabinet_sizes = {},
				cabinet_size_options = [];
			payload.cabinets.forEach(row => {
				let width = Math.floor(parseFloat(row.width));
				if(cabinet_sizes[width] == undefined){
					cabinet_sizes[width] = [];
					cabinet_size_options.push(width);
				}
				cabinet_sizes[width].push(row);
			});
			state.cabinet_size_options = cabinet_size_options;
			state.cabinet_sizes = cabinet_sizes;

			/* make sure the to select default things. */
			
			// set the current selected size:
			let defaultSize = null;
			// find default size
			for(let i in payload.sizes){
				let size = payload.sizes[i];
				if (size.mattress_size.is_default === 1){
					defaultSize = size;
					break;
				}
			}
			// if no default use first one.
			if(defaultSize == null) defaultSize = payload.sizes[0];
			state.selected_size = defaultSize;
			state.selected_popular_finish = null;
			// woods based on selected size.
			let woods = [];
			defaultSize.prices.forEach(row => {
				row.woods.forEach(wood => {
					woods.push(wood);
				});
			});
			state.woods = woods;
			// default wood
			const defaultWood = woods[0];
			state.selected_wood = defaultWood;
			state.wood_finishes = defaultWood.finishes;
			state.selected_finish = defaultWood.finishes[0];
			// available  mattresses
			state.mattresses = defaultSize.mattresses;
			// selected depth_price (heardboard)
			state.selected_headboard = payload.depth_prices[0];

			// handle selected desk options
			let options = [];
			state.front_panel_upcharges.forEach(price => {
				price.woods.forEach(w => {
					if(w.id == defaultWood.id){
						options.push(price);
					}
				})
			});
			state.desk_table_options = options;

			setTimeout(() => updateCabinetFollowUpForm(state),0);
		},
		/**
		 * user has selected a size.
		 * save it in the state
		 * @param {[type]} state   [description]
		 * @param {[type]} payload [description]
		 */
		setSelectedSize(state,size){
			state.selected_size = size;
			let woods = [];
			size.prices.forEach(row => {
				row.woods.forEach(wood => {
					woods.push(wood);
				});
			});
			state.woods = woods;
			state.mattresses = size.mattresses;
			//state.popular_finishes = size.popular;
			//state.selected_popular_finish = null; // reset.
			state.selected_left_cabinet_size = "none";
			state.selected_right_cabinet_size = "none";
			state.selected_left_cabinet_style = null;
			state.selected_right_cabinet_style = null;
			state.selected_desk_table = null;
			
			setTimeout(() => updateCabinetFollowUpForm(state),0);
		},
		/**
		 * save the wood the user has selected
		 * also save list of finishes for that wood
		 * @param {[type]} state [description]
		 * @param {[type]} wood  [description]
		 */
		setSelectedWood(state,wood){
			state.selected_wood = wood;
			state.selected_finish = null;
			state.wood_finishes = wood.finishes;
			// loop through front_panel_upcharges match wood
			let options = [];
			state.front_panel_upcharges.forEach(price => {
				price.woods.forEach(w => {
					if(w.id == wood.id){
						options.push(price);
					}
				})
			});
			state.selected_finish = state.wood_finishes[0];
			state.desk_table_options = options;
			setTimeout(() => updateCabinetFollowUpForm(state),0);
		},
		setSelectedFinish(state,finish){
			state.selected_finish = finish;
			setTimeout(() => updateCabinetFollowUpForm(state),0);
		},
		setSelectedHeadboard(state,payload){
			state.selected_headboard = payload;
			setTimeout(() => updateCabinetFollowUpForm(state),0);
		},
		setSelectedDeskTable(state,payload){
			state.selected_desk_table = payload;
			setTimeout(() => updateCabinetFollowUpForm(state),0);
		},
		setSelectedAdditionalOptions(state,payload){
			state.selected_options = payload;
			if(document.cabinetBedCalculator && state.cabinetBed != null && state.cabinetBed.type){
				document.cabinetBedCalculator.calculateTotals();
			} else {
				setTimeout(() => updateCabinetFollowUpForm(state),0);
			}
		},
		setSelectedCabinetLeft(state,payload){
			state.selected_cabinet_left = payload;
			setTimeout(() => updateCabinetFollowUpForm(state),0);
		},
		setSelectedCabinetRight(state,payload){
			state.selected_cabinet_right = payload;
			setTimeout(() => updateCabinetFollowUpForm(state),0);
		},
		setInfoData(state,payload){
			state.current_info_data = payload;
		},
		setSelectedMattress(state,payload){
			state.selected_mattress = payload;
			if(document.cabinetBedCalculator && state.cabinetBed != null && state.cabinetBed.type){
				document.cabinetBedCalculator.calculateTotals();
			} else {
				setTimeout(() => updateCabinetFollowUpForm(state),0);
			}
		},
		setSelectedPopularFinish(state,payload){
			state.selected_popular_finish = payload;
			setTimeout(() => updateCabinetFollowUpForm(state),0);
		},
		setSelectedSofaFabric(state, payload){
			state.selected_fabric = payload;
		},
		/**
		 * totals are calculated in header component
		 * @param {[type]} state   [description]
		 * @param {[type]} payload [description]
		 */
		setTotals(state,payload){
			state.totals = payload;
		},
		setSelectedCabinetSize(state,payload){
			state[`selected_${payload.side}_cabinet_size`] = payload.size;
			setTimeout(() => updateCabinetFollowUpForm(state),0);
		},
		setSelectedCabinetStyle(state,payload){
			state[`selected_${payload.side}_cabinet_style`] = payload.style;
			setTimeout(() => updateCabinetFollowUpForm(state),0);
		},
		setPricingItems(state,payload){
			state.pricing_items = payload;
		},
		/**
		 * save WordPress nonce.
		 * @param state
		 * @param payload
		 */
		setNonce(state,payload){
			state.wp_nonce = payload;
		},
		/**
		 * save WooCommerce Product ID
		 * @param {[type]} state   [description]
		 * @param {[type]} payload [description]
		 */
		setProductId(state,payload){
			state.product.id = payload;
		},
		updateCabinetNightTray(state,payload){
			state[`${payload.side}_cabinet_night_tray`] = payload.value;
			setTimeout(() => updateCabinetFollowUpForm(state),0);
		},
		updateCabinetGlassDoors(state,payload){
			state[`${payload.side}_cabinet_glass_doors`] = payload.value;
			setTimeout(() => updateCabinetFollowUpForm(state),0);
		},
		updateCabinetGlassShelves(state,payload){
			state[`${payload.side}_cabinet_glass_shelves`] = payload.value;
			setTimeout(() => updateCabinetFollowUpForm(state),0);
		},
		setCabinetBed(state,payload){
			state.cabinetBed = payload;
			if(document.cabinetBedCalculator && state.cabinetBed != null && state.cabinetBed.type){
				document.cabinetBedCalculator.calculateTotals();
			}
		},
		setSelectedCabinetBedColor(state,payload){
			state.cabinetBedColor = payload;
			if(document.cabinetBedCalculator && state.cabinetBed != null && state.cabinetBed.type){
				document.cabinetBedCalculator.calculateTotals();
			}
		}
	},
	actions: {
		
	}
})

function setFollowUpFieldValue(state,field,value){
	document.getElementById(`input_${state.followup_mapping.form_id}_${state.followup_mapping[field]}`).value = value;
}
/**
 * check all data for the follow up form.
 * @return {[type]} [description]
 */
function updateCabinetFollowUpForm(state){
	if(document.cabinetBedCalculator && state.cabinetBed != null && state.cabinetBed.type){
		document.cabinetBedCalculator.calculateTotals();
	}
	const form = document.getElementById(`gform_${state.followup_mapping.form_id}`);	
	if(form == null) return;
	// set field style:
	setFollowUpFieldValue(state,'style',state.wallbed.name);
	// selected wood
	setFollowUpFieldValue(state,'wood', state.selected_wood.name);
	// set finish
	setFollowUpFieldValue(state,'finish',(state.selected_finish == null)? "N/A" : state.selected_finish.name);
	// set headboard
	state.selected_headboard ? setFollowUpFieldValue(state,'headboard',state.selected_headboard.name):null;
	// set selectedSize
	setFollowUpFieldValue(state,'size',state.selected_size.mattress_size.name);
	// set desk table option
	setFollowUpFieldValue(state,'drop_down_table',state.selected_desk_table == null ? "N/A" : state.selected_desk_table.front_panel_type.name);
	// additional options
	if(state.selected_options.length == 0){
		setFollowUpFieldValue(state,'additional_options',"N/A");
	}else{
		let optionNames = [];
		for(let o in state.selected_options){
			optionNames.push(state.selected_options[o].name);
		}
		// set desk table option
		setFollowUpFieldValue(state,'additional_options',optionNames.join(", "));
	}
	// set selected mattress
	setFollowUpFieldValue(state,'mattress',(state.selected_mattress == null)? "N/A" : state.selected_mattress.name);
	// left cabinet
	if(state.selected_cabinet_left== null){
		setFollowUpFieldValue(state,'left_cabinet',"N/A");
		setFollowUpFieldValue(state,'left_cabinet_width',"N/A");
	}else{
		let cabinet = state.selected_cabinet_left.cabinet_type.name;
		if(state.left_cabinet_night_tray) cabinet += " Slide-out Night Tray";
		if(state.left_cabinet_glass_doors) cabinet += " Glass Doors";
		if(state.left_cabinet_glass_shelves) cabinet += " & Shelf";
		setFollowUpFieldValue(state,'left_cabinet',cabinet);
		setFollowUpFieldValue(state,'left_cabinet_width',state.selected_left_cabinet_size + '"');
	}
	// right cabinet
	if(state.selected_cabinet_right == null){
		setFollowUpFieldValue(state,'right_cabinet',"N/A");
		setFollowUpFieldValue(state,'right_cabinet_width',"N/A");
	}else{
		let cabinet = state.selected_cabinet_right.cabinet_type.name;
		if(state.right_cabinet_night_tray) cabinet += " Slide-out Night Tray";
		if(state.right_cabinet_glass_doors) cabinet += " Glass Doors";
		if(state.right_cabinet_glass_shelves) cabinet += " & Shelf";
		setFollowUpFieldValue(state,'right_cabinet',cabinet);
		setFollowUpFieldValue(state,'right_cabinet_width',state.selected_right_cabinet_size + '"');
	}
}
